module.exports = __webpack_public_path__ + "img/news1.85171093.svg";